import { mapValues } from 'lodash';

import { LocalStorageCompatible } from './local-storage-compatible';
import {
  ChartGlobalConfig as ChartGlobalConfigV15,
  isLocalStorageV15,
  LocalStorageV15,
} from './local-storage-v15';
import { upgrade as upgradeFromPrevious } from './local-storage-v15.upgrade';
import { ChartGlobalConfig as ChartGlobalConfigV16, LocalStorageV16 } from './local-storage-v16';

function smoothingWindowModeToAlgorithm(
  smoothingWindowMode: ChartGlobalConfigV15['smoothingWindowMode'],
): ChartGlobalConfigV16['smoothingAlgorithm'] | undefined {
  switch (smoothingWindowMode) {
    case 'ema':
      return 'emaCausal';
    case 'gaussian':
      return 'gaussianCentered';
    case 'causal':
      return 'smaCausal';
    case 'centered':
      return 'smaCentered';
  }

  return undefined;
}

/*
 * NOTE: Create new migration files only when you need to remove or edit existing field. Do not create new migration file for adding new field.
 */
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV16> {
  const input: LocalStorageV15 = isLocalStorageV15(raw) ? raw : await upgradeFromPrevious(raw);
  const { data } = input;

  const { chartWidgetOptionsByProject, chartGlobalConfig, ...rest } = data;

  const newChartWidgetOptionsByProject: LocalStorageV16['data']['chartWidgetOptionsByProject'] =
    mapValues(chartWidgetOptionsByProject, (projectChartOptions) => {
      return mapValues(projectChartOptions, ({ smoothingWindowMode, ...chartOptions }) => {
        return {
          ...chartOptions,
          smoothingAlgorithm: smoothingWindowModeToAlgorithm(smoothingWindowMode),
        };
      });
    });

  const newChartGlobalConfig: LocalStorageV16['data']['chartGlobalConfig'] = mapValues(
    chartGlobalConfig,
    ({ smoothingWindowMode, ...config }) => {
      return {
        ...config,
        smoothingAlgorithm: smoothingWindowModeToAlgorithm(smoothingWindowMode),
      };
    },
  );

  return {
    version: 16,
    data: {
      ...rest,
      chartWidgetOptionsByProject: newChartWidgetOptionsByProject,
      chartGlobalConfig: newChartGlobalConfig,
    },
  };
}
